import * as React from "react";
import { deviceType } from "../../components/Helper";
import { colors } from "../Helper";

export const InfoTable = (props: any) => {
    const type: string = props?.type;
    const isCnano: boolean = type === deviceType.CNANO;

    const calculateHeader = (i: number) => {
        const idx = props?.rowIds?.indexOf(i);
        if (idx !== -1) {
            return <td rowSpan={props?.span} className={`vertical-text ${colors[idx]}`}>{`Extension Header ${idx + 1} (EXT ${idx + 1})`}</td>
        }
    }

    return <React.Fragment>
        <table className="main-table">
            <thead>
                <tr>
                    <th scope="col" colSpan={isCnano ? 4 : 3} className="header"></th>
                    <th scope="col" className="header">{type} Board</th>
                    <th scope="col" className="header">Touch Extenstion Board</th>
                    <th scope="col" className="header"></th>
                </tr>
            </thead>
            <thead>
                <tr>
                    <th scope="col" className="header"></th>
                    <th scope="col" className="header">EXT Pin #</th>
                    {isCnano ? <th scope="col" className="header">Touch Adapter</th> : ""}
                    <th scope="col" className="header">Function</th>
                    <th scope="col" className="bg-yellow">{props?.mcu}</th>
                    <th scope="col" className="bg-yellow">{props?.ext.replaceAll("_", " ")}</th>
                    <th scope="col" className="header">Notes**</th>
                </tr>
            </thead>
            <tbody>
                {
                    props?.data?.map((row: any, i: number) => {
                        return <tr>
                            {calculateHeader(i)}
                            <td className={row?.color}>{row?.pin}</td>
                            {type === deviceType.CNANO ? <td className={row?.color}>{row?.adapter}</td> : ""}
                            <td className={row?.color}>{row?.function}</td>
                            <td className={row?.color}>{!row?.mcuInfo || row?.mcuInfo?.replaceAll(" ", "") === "" ? "--" : row?.mcuInfo}</td>
                            <td className={row?.color}>{row?.extData === "---" ? "NC" : row?.extData}</td>
                            <td className={row?.color}>{!row?.mcuInfo || row?.note?.replaceAll(" ", "") === "" ? "--" : row?.note}</td>
                        </tr>
                    })
                }
            </tbody>
        </table>
    </React.Fragment>
}